import cn from "@/lib/cn";
import { CSSProperties } from "react";

interface MonarchFallbackProps {
  height: [string, string, string]; // [mobile, tablet, desktop]
}

export default function MonarchFallback({ height }: MonarchFallbackProps) {
  return (
    <div
      style={
        {
          "--mobile": height[0],
          "--tablet": height[1],
          "--desktop": height[2],
        } as CSSProperties
      }
      className={cn(
        "relative min-h-[var(--mobile)] md:min-h-[var(--tablet)] xl:min-h-[var(--desktop)]"
      )}
    />
  );
}
